<template>
  <Teleport to="body">
    <div class="darken-page profile-preview-overlay" @click="close()"></div>

    <div class="profile-preview" v-if="profile">
      <button id="close-profile-preview" @click="close()">
          <p>Schließen</p> <img src="@/assets/images/cross.svg">
      </button>
      <div class="profile-info">
            <h2 id="profile">{{profile.name}}</h2>
            <div class="profile-stat">
              <img src="@/assets/images/cake.svg">
              <p><b>{{profile.age}}</b> Jahre</p>
            </div>
            <div class="profile-stat">
              <img src="@/assets/images/person-height.svg">
              <p><b>{{profile.height}}</b> cm</p>
            </div>
            <div class="profile-stat" v-if="profile.gender">
              <img src="@/assets/images/account.svg">
              <p>{{ {male: 'Männlich', female: 'Weiblich', diverse: 'Divers'}[profile.gender] }}</p>
            </div>
            <div class="profile-stat" v-if="profile.looking_for">
              <img src="@/assets/images/search.svg">
              <p>{{profile.looking_for}}</p>
            </div>
            <div class="profile-stat" v-if="profile.availability && profile.availability.length > 0">
              <img src="@/assets/images/calendar.svg">
              <div class="profile-dates" v-if="profile.availability"><p v-for="av in profile.availability" :key="av.name">{{av.name}}</p></div>
            </div>
            <div class="profile-stat profile-note" v-if="profile.short_bio">
              <img src="@/assets/images/notes.svg">
              <p style="word-break: break-all; white-space: normal;">{{profile.short_bio}}</p>
            </div>
            <h3>Details</h3>
            <div class="details-container" id="details">
              <p>{{profile.long_bio}}</p>
              <p v-if="!profile.long_bio || profile.long_bio === ''"><i>Keine Beschreibung vorhanden.</i></p>
            </div>
            <div class="details-container" id="details" v-if="profile.images && profile.images.length > 0">
              <div class="photos-container" id="photos">
                <div class="single-photo" v-for="(image, i) in profile.images" :key="i">
                  <img v-if="image" :src="image">
                </div>
              </div>
            </div>
          </div>
          <div class="vote-action" v-if="showVoteAction">
            <h2>Meinung geändert?</h2>
            <button
              class="vote-toggle-btn"
              :class="{liked: !(voteLiked === 1 || voteLiked === true)}"
              :disabled="voteUpdating"
              @click="toggleVote()"
            >
              <img :src="(voteLiked === 1 || voteLiked === true) ? crossIcon : checkIcon">
              <span>{{ (voteLiked === 1 || voteLiked === true) ? 'Als nicht gemocht markieren' : 'Als gemocht markieren' }}</span>
            </button>
            <p class="vote-error" v-if="voteError">{{voteError}}</p>
          </div>
    </div>
    <MatchModal :show="showMatchModal" :match-name="profile ? profile.name : null" :match-id="matchModalMatchId" @close="showMatchModal = false" />
  </Teleport>
</template>

<script>
import AuthService from '@/services/AuthService.js';
import moment from 'moment';
import checkIcon from '@/assets/images/check.svg';
import crossIcon from '@/assets/images/cross.svg';
import MatchModal from '@/components/MatchModal.vue';

export default {
  name: 'ProfilePreview',
  components: {
    MatchModal
  },
  data() {
    return {
        profile: null,
        voteLiked: this.initialLiked,
        voteUpdating: false,
        voteError: null,
        showMatchModal: false,
        matchModalMatchId: null,
        checkIcon,
        crossIcon
    }
  },
  props: {
    profile_id: String,
    showVoteAction: {
      type: Boolean,
      default: false
    },
    initialLiked: {
      type: [Number, Boolean],
      default: null
    }
  },
  emits: ['close', 'vote-changed'],
  methods: {
    async toggleVote() {
      if(this.voteUpdating || !this.profile) return
      this.voteUpdating = true
      this.voteError = null
      const newLiked = (this.voteLiked === 1 || this.voteLiked === true) ? false : true
      try {
        let result = await AuthService.matchCastVote({
          target_id: this.profile.profile_id,
          pool_id: this.profile.pool_id,
          liked: newLiked
        })
        if(result.success) {
          this.voteLiked = newLiked ? 1 : 0
          if(result.matched === true) {
            this.matchModalMatchId = result.match_id
            this.showMatchModal = true
          }
          this.$emit('vote-changed', {target_id: this.profile.profile_id, liked: this.voteLiked, matched: result.matched, match_id: result.match_id})
        } else {
          this.voteError = "Vote konnte nicht geändert werden."
        }
      } catch(e) {
        console.error(e)
        this.voteError = "Vote konnte nicht geändert werden."
      }
      this.voteUpdating = false
    },
    async fetchProfile(profile_id){
      let profile = await AuthService.getSingleProfile({profile_id: profile_id});
      if(!profile.success) {
        console.error(profile)
      } else if (profile.msg.length > 0) {
        this.profile = await Promise.all(
                  profile.msg.map(async p => {
                    p.images = await this.loadImages(p.profile_id);
                    return p;
                  })
              );

        this.profile = {
            ...profile.msg[0], 
            "age": Math.floor(moment().diff(moment(profile.msg[0].birthday), 'days') / 365),
            "birthday": moment(profile.msg[0].birthday).format("YYYY-MM-DD"),
            "availability": profile.msg[0].availability ? JSON.parse(profile.msg[0].availability) : []
        }
      }
    },
    async loadImages(profile_id) {
      let result = await AuthService.getProfileImages({ profile_id: profile_id });
      if (!result.success) return false;

      return await Promise.all(
          result.msg.map(async image_id => {
            try {
              const img = await AuthService.getImage({ image_id: image_id.image_id });
              return URL.createObjectURL(img);
            } catch (error) {
              if (error.response && error.response.status === 404) {
                console.warn(`Bild mit ID ${image_id.image_id} nicht gefunden (404).`);
                return null;
              } else {
                console.error(`Fehler beim Laden des Bildes ${image_id.image_id}:`, error);
                return null;
              }
            }
          })
      );
    },
    close() {
      this.$emit('close')
    }
  },
  async mounted() {
    if(this.profile_id) await this.fetchProfile(this.profile_id)
  }
};
</script>

<style scoped>
#close-profile-preview {
    display: flex;
    align-items: center;
    justify-content: end;
    margin: 0 0 10px 0;
    border: none;
    background: none;
    gap: 4px;
    width: 100%;
}

#close-profile-preview p {
    font-size: 1rem;
    margin: 0;
    padding: 0;
    color: #1D1D1F;
}

#close-profile-preview img {
    width: 15px;
    height: 15px;
}

.profile-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  scroll-behavior: smooth;
  overflow-y: auto;
  transition: all ease 0.2s;
  flex: 1;
}

.profile-info h2 {
  font-size: 2rem;
  font-weight: 800;
  margin: 0 0 10px 0;
}

.profile-info h3 {
  margin: 20px 0 0 0;
}

.profile-info p {
  margin: 0;
}

.profile-stat {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.profile-stat p {
  text-align: left;
}

.profile-stat img {
  width: 18px;
  height: 18px;
  opacity: 0.6;
}

.profile-dates {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.profile-dates p {
  background: var(--secondary-color);
  padding: 6px 10px;
  border-radius: 15px;
  color: white;
  font-size: 0.85rem;
  font-weight: 600;
}

.profile-preview-overlay {
  z-index: 1000;
}

.vote-action {
  margin-top: 16px;
  flex-shrink: 0;
}

.vote-toggle-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px;
  border-radius: var(--radius-m);
  border: none;
  background: #FFEBEE;
  font-family: var(--font);
  font-size: 0.95rem;
  font-weight: 700;
  color: #1D1D1F;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.1s ease;
}

.vote-toggle-btn:active {
  transform: scale(0.98);
}

.vote-toggle-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.vote-toggle-btn.liked {
  background: #E8F5E9;
}

.vote-toggle-btn img {
  width: 18px;
  height: 18px;
  filter: invert(30%) sepia(80%) saturate(2000%) hue-rotate(330deg) brightness(100%) contrast(100%);
}

.vote-toggle-btn.liked img {
  filter: invert(48%) sepia(70%) saturate(400%) hue-rotate(80deg) brightness(95%) contrast(90%);
}

.vote-error {
  color: #FF3B30;
  font-size: 0.85rem;
  font-weight: 600;
  margin-top: 8px;
  text-align: center;
}

.details-container p {
    text-align: left;
    word-break: break-word;
    white-space: break-spaces;
    color: var(--text-secondary);
}

.photos-container {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  width: 100%;
  margin-top: 20px;
  padding-bottom: 10px;
}

.single-photo img {
  width: 200px;
  height: 260px;
  object-fit: cover;
  border-radius: var(--radius-m);
}

.profile-preview {
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 440px;
  max-height: 80vh;
  background: white;
  padding: 24px;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-strong);
  display: flex;
  flex-direction: column;
  z-index: 1001;
  animation: fly-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

@keyframes fly-in {
    from {
        transform: translate(-50%, 100vh) rotate(-10deg);
        opacity: 0;
    }
    to {
        transform: translate(-50%, 0) rotate(0);
        opacity: 1;
    }
}
</style>
